export const USER_AUTHENTICATION_COOKIE = 'user-authentication';
export const USER_PHONE_NUMBER = 'user-phone-number';
export const USER_SUBDOMAIN = 'user-subdomain';
export const UTM_COOKIE_NAME = 'utm-data';
